export default {
    methods: {
      async _XtravesalQA(categories){
        for(var category of categories){
          this.questionnaires.push({category:true, name:category.name, count:0});
          for(var question of category.questions){
            //console.log(question);
            for(var subquestion of question.subquestions){
              var finalScore;
              if(subquestion.useranswer.correct==true)
                  finalScore = subquestion.score;
              else
                  finalScore = 0;
              this.finalScore = this.finalScore + finalScore;
              this.totalScore = this.totalScore + subquestion.score
              this.questionnaires.push({category:false, name:subquestion.title, score: subquestion.score, finalscore: finalScore});
              for(var answer of subquestion.answers){
                //console.log(answer);
              }
            }
          }
        }
      },
      async _getXAsuulgaCategories(qaRef){
            this.questionCount=0;
            if(this.questionnaires==null || (this.questionnaires!=null && this.questionnaires.length==0)){
              var ref=qaRef.collection("tests").orderBy("createdAt");
              ref.get().then(categoriesData=>{
                this.questionnaires=[];
                categoriesData.forEach(doc=> {
                    let category=doc.data();
                    category.id = doc.id;
                    category.answeredCount=0;
                    // if(category.questions==null || category.questions==undefined)
                      category.questions=[];
                    if(category.showquestions==null || category.showquestions==undefined)
                      category.showquestions=[];
                    this._getXAsuulgaQuestions(category, doc.ref);
                   // this.categories.push(category); TODO
                });
 
              });
            }
          },
          _getXAsuulgaQuestions(category, categoryRef){
            if(category.questions==null || (category.questions!=null && category.questions.length==0)){
              categoryRef.collection("questions").orderBy("createdAt").get().then(qDatas=>{
                  qDatas.forEach(questionData=> {
          
                      let question=questionData.data();
                      this.questionCount++;
                      question.id = questionData.id;
                      question.subquestions=[];
                        
                      this._getXAsuulgaSubquestions(question, categoryRef, questionData.ref);
                      //category.questions.push(question); TODO
                    
                  });
              });
            }
          },
          _getXAsuulgaSubquestions(object, parentRef, questionRef,){
            if(object.subquestions==null || (object.subquestions!=null && object.subquestions.length==0)){
              questionRef.collection("subquestions").orderBy("index").get().then(qDatas=>{
                  qDatas.forEach(questionData=> {
                      let sq=questionData.data();
                      // this.questionCount++;
                      //   object.numbering=this.questionCount;
                      sq.id = questionData.id;
                      // sq.mcanswers=[];
                      //   sq.answers=[];
                      //   sq.answered=false;
                        // this._getAnswers(sq, questionData.ref, true, category);
                        // this._getUserAnswerSq(sq, questionData.ref, category, object);
                        // this._getAnswers(sq, questionData.ref, true, category, object);
                        // if(object.multichoice!=true)
                        //   this._getUserAnswer2(sq, questionData.ref, category, object);
                      //object.subquestions.push(sq);
                      this.questionnaires.push(sq);
                  });
              });
            }
          },
          _getUserAnswer2(question, ref, category, topquestion){
            if(question.useranswer==undefined)
                    question.useranswer=null;
            
                this.userRound.ref.collection("categories").doc(category.id).collection('roundCategoryQuestions').doc(question.id).onSnapshot(doc=> {
                
                question.useranswer=null;
                if (doc.exists && question.multichoice!=true) {
                    question.useranswer=doc.data();
                    // if(question.answered!=true && category!=null)
                    //   category.answeredCount++;
    
                    if(question.answered!=true){
                      if(topquestion.answeredCount==null)
                        topquestion.answeredCount=0;
                      topquestion.answeredCount++;
                      if(topquestion.answeredCount==topquestion.subquestions.length){
                        topquestion.answered=true;
                        if(category!=null)
                          category.answeredCount++;
                      }
                    }
                    question.answered=true;
                    // question.answered=true;
                    // if(question.multichoice==true){
                    //   if(question.answeredCount==null)
                    //     question.answeredCount=0;
                    //   question.answeredCount++;
                    // }
                }
            });  
          },
          _getUserAnswerText(question, ref, category){
            var userId='qa_'+this.qa.id+"_user";
    
            if(question.useranswer==null || question.useranswer==undefined)
                    question.useranswer=null;
            ref.collection("votedusers").doc($cookies.get(userId)).onSnapshot(doc=> {
                
                question.useranswer=null;
                if (doc.exists) {
                    question.useranswer=doc.data()
                    if(question.answered!=true && category!=null)
                      category.answeredCount++;
                    question.answered=true;
                }
              question.currentAnswerActive=false;
            });  
            
          },
        _getAnswers(question, ref, getResult, category, topquestion){
          if(question.answers==null || (question.answers!=null && question.answers.length==0)){
            if(question.answertype==true && getResult==true){
              this._getUserAnswerText(question, ref, category)
            }
            else{
              ref.collection("answers").orderBy("index").get().then(querySnapshot=> {
                  question.answers=[];
                  var tmp=[];
                  querySnapshot.forEach(doc=> {
                      let answer=doc.data();
                      answer.id = doc.id;
                      if(question.multichoice==true && getResult==true)
                        this._getUserAnswer(answer, ref, question, category, topquestion);
    
                      tmp.push(answer);
                  });
                  question.answers=this.shuffle(tmp);
              });
            }
          }
          else{
            if(question.answertype==true && getResult==true){
              this._getUserAnswerText(question, ref, category)
            }
            else{
              question.answers.forEach((answer)=> {
                if(question.multichoice==true && getResult==true)
                  this._getUserAnswer(answer, ref, question, category, topquestion);
              });
    
            }
          }
        },

        _getUserAnswer(answer, ref, question, category, topquestion){

            if(answer.useranswer==undefined)
                    answer.useranswer=null;
            this.userRound.ref.collection("categories").doc(category.id).collection('roundCategoryQuestions').doc(question.id).onSnapshot(doc=> {
                
                answer.useranswer=null;
                if (doc.exists) {
                  var exists=false;
                  var index=0;
                  if(question.answeredCount==null)
                        question.answeredCount=0;
                  doc.data().answers.forEach((uanswer, aindex)=>{
                    if(uanswer.answer.id==answer.id){
                      exists=true;
                      index=aindex;
                    }
                  });
                  question.mcanswers=doc.data().answers;
    
                  if(exists==true){
                    answer.useranswer=doc.data().answers[index];
    
    
                    if(question.answered!=true){
    
                      question.answeredCount++;
    
                      if(topquestion.answeredCount==null)
                        topquestion.answeredCount=0;
                      
                      topquestion.answeredCount++;
    
                      if(topquestion.answeredCount==topquestion.subquestions.length){
                        topquestion.answered=true;
                        if(category!=null)
                          category.answeredCount++;
                      }
                      question.answered=true;
                    }
                    else
                      question.answered=true;
                  }
                }
            });  
    
          },
          shuffle:function (a) {
            var j, x, i;
            for (i = a.length - 1; i > 0; i--) {
                j = Math.floor(Math.random() * (i + 1));
                x = a[i];
                a[i] = a[j];
                a[j] = x;
            }
            return a;
        },
 
    },
}